import { useScreenSize } from "hooks";
import React from "react";
import NgoDashboardDesktop from "./ngo-dashboard-container/desktop";
import NgoDashboardMobile from "./ngo-dashboard-container/mobile";

export default function NgoDashboardContainer({ dashboard }: any) {
  const { isDesktop, isMobile } = useScreenSize();

  let NgoDashboardContent;

  switch (true) {
    case isDesktop:
      NgoDashboardContent = <NgoDashboardDesktop dashboard={dashboard} />;
      break;

    case isMobile:
      NgoDashboardContent = <NgoDashboardMobile dashboard={dashboard} />;
      break;

    default:
      NgoDashboardContent = <div></div>;
  }

  return NgoDashboardContent;
}
